import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigServerService, CustomHttp } from '../../../core';
import { VisualizacaoModo, isVisualizacaoModoPipeline } from '../../../common/visualizacao-modo';
import { PedidoSearch } from '../pedido-search';
import { PedidoSearchTotal } from '../pedido-search-total';
import { PedidoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class PedidoSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Pesquisa os pedidos */
    search(params: HttpParams, filter: PedidoFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<PedidoSearch[]> {
        if (!params) {
            params = new HttpParams();
        }

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        // return this.customHttp.get<PedidoSearch[]>(this.pathApi, {params: params});
        return this.customHttp.get<PedidoSearch[]>(`${this.pathApi}/0/search`, {params})
                    .pipe(
                        map((pedidos: PedidoSearch[]) => {
                            if (!pedidos) {
                                return [];
                            }

                            return pedidos.map((pedido: PedidoSearch) => pedido = new PedidoSearch(pedido));
                        })
                    );
    }

    /** Pesquisa um único pedido através do ID informado */
    searchOne(id: number): Observable<PedidoSearch> {
        return this.customHttp.get<PedidoSearch>(`${this.pathApi}/${id}/search/one`);
    }

    /** Obtem os totais da pesquisa dos registros da carteira de clientes */
    getTotais(params: HttpParams, filter: PedidoFilter): Observable<PedidoSearchTotal> {
        if (!params) {
            params = new HttpParams();
        }

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<PedidoSearchTotal>(`${this.pathApi}/0/total`, {params});
    }

    /** Pesquisa os pedidos pelos status informados */
    searchStatus(visualizacaoModo: VisualizacaoModo, status: number[], filter: PedidoFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<PedidoSearch[]> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Status
        if (isVisualizacaoModoPipeline(visualizacaoModo?.id)) { // Se for o modo de visualização pipeline removemos e adicionandos os status explicitamentes informadas
            params = params.delete('status');
            status?.forEach(s => {
                params = params.append('status', s ? s.toString() : null);
            });
        }

        return this.search(params, null, orderBy, orderByDir, limit, offset);
    }

    /** Obtem os totais dos pedidos pelos status informados */
    getTotaisStatus(visualizacaoModo: VisualizacaoModo, status: number[], filter: PedidoFilter): Observable<PedidoSearchTotal> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Status
        if (isVisualizacaoModoPipeline(visualizacaoModo?.id)) { // Se for o modo de visualização pipeline removemos e adicionandos os status explicitamentes informadas
            params = params.delete('status');
            status?.forEach(s => {
                params = params.append('status', s ? s.toString() : null);
            });
        }

        return this.getTotais(params, null);
    }
}
